import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Title from '../title';
import { Modal, ModalContain, Button, Description } from './styles';

export default class Portal extends Component {
  portalRoot = typeof document !== `undefined` ? document.getElementById('portal') : null;
  el = typeof document !== `undefined` ? document.createElement('div') : null;

  componentDidMount() {
    this.portalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    this.portalRoot.removeChild(this.el);
  }

  renderModal() {
    const { children, title, description, onClicked, ...rest } = this.props;
    return (
      <Modal>
        <ModalContain {...rest}>
          <Button type="button" onClick={onClicked}>×</Button>
          {title && <Title small>{title}</Title>}
          {description && <Description>{description}</Description>}

          {children}
        </ModalContain>
      </Modal>
    );
  }

  render() {
    if (this.el) {
      return ReactDOM.createPortal(this.renderModal(), this.el);
    } else {
      return null;
    }
  }
}
